import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/redmore.webp';
import screenshot_target from '../../../images/letterfunnel/arjendeboer.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Arjen de Boer"
      firstname="Arjen"
      companyname="Redmore"
      competition="Yacht en Team EIFFEL"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/arjendeboer.js